import { createGlobalStyle } from 'styled-components';

import tokens from './tokens';

export default createGlobalStyle`
  /* Os .woff2 sao a fonte de verdade: os arquivos originais .otf (CFF, sem
     hinting) e .ttf (conversao FontForge, com hinting quebrado) deformavam os
     glifos em tamanhos pequenos no Windows. Os .woff2 dos pesos 500/600 foram
     gerados sem hinting, deixando a rasterizacao com o DirectWrite/Skia.
     Os formatos antigos ficam so como fallback para navegadores sem woff2. */
  @font-face {
    font-family: 'Avenir Next';
    src: url('/fonts/AvenirNext-Regular.woff2') format('woff2'),
      url('/fonts/AvenirNext-Regular.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Avenir Next';
    src: url('/fonts/AvenirNext-Medium.woff2') format('woff2'),
      url('/fonts/AvenirNext-Medium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Avenir Next';
    src: url('/fonts/AvenirNext-DemiBold.woff2') format('woff2'),
      url('/fonts/AvenirNext-DemiBold.ttf') format('truetype');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Avenir Next';
    src: url('/fonts/AvenirNext-Bold.woff2') format('woff2'),
      url('/fonts/AvenirNext-Bold.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  ${tokens}

  :root{
    --input-height: 5rem;
    --button-height: 5rem;
  }

  *{
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  body, p, a, input, h1, h2, h3, h4, textarea, option, select, button, label {
    font-family: var(--font-sans);
  }

  body, p, a, input, textarea, .react-select__placeholder {
    font-weight: 400;
    font-size: 1.5rem;
    color: var(--font-color);
  }

  body {
    background-color: var(--bg);
    color: var(--ink);
    -webkit-font-smoothing: antialiased;
    transition: background-color var(--dur-base) var(--ease-standard),
      color var(--dur-base) var(--ease-standard);
  }

  h1, h2, h3, h4 {
    font-family: var(--font-display);
    color: var(--ink);
    letter-spacing: -0.02em;
  }

  input, textarea, select {
    background-color: var(--surface);
    color: var(--ink);
  }

  input {
    height: var(--input-height);
  }

  input, textarea {
    padding-left: 15px;
    padding-right: 15px;
    resize: none;

    ::placeholder {
      color: var(--ink-faint);
    }
  }

  button {
    height: var(--button-height);
  }

  html, body {
    height: 100vh;
  }

  /* O scroll da aplicação vive neste wrapper (public/index.html), então o fundo
     do tema precisa ser pintado nele também. */
  #scroller {
    background-color: var(--bg);
  }

  #root {
    height: 100%;
  }

  html {
    font-size: 62.5%; /* 1 rem = 10px */
  }

  @media (max-width: 800px) {
    html {
      font-size: 56.25%; /* 1 rem = 9px */
    }
  }

  h1 {
    font-size: 3.2rem;
  }

  h2 {
    font-size: 2.4rem;
  }

  button {
    cursor: pointer;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ::selection {
    background: var(--accent);
    color: #fff;
  }

  :focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 2px;
    border-radius: var(--r-xs);
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.001s !important;
      transition-duration: 0.001s !important;
    }
  }

  /* Loading indicator */
  .loader {
    z-index: 99999;
    border: 6px solid var(--border);
    border-radius: 50%;
    border-top: 6px solid var(--accent);
    width: 5.6rem;
    height: 5.6rem;
    position: fixed;
    top: 40%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    -webkit-animation: spin var(--dur-spin) linear infinite;
    animation: spin var(--dur-spin) linear infinite;

    /* Ver o mixin spinner, em mixins.js: zerar a duração de um giro infinito
       não reduz movimento, acelera. */
    @media (prefers-reduced-motion: reduce) {
      -webkit-animation-duration: var(--dur-spin-reduced) !important;
      animation-duration: var(--dur-spin-reduced) !important;
    }
  }

  .loader-accent {
    border-top: 6px solid var(--laranja);
  }

  /* Safari */
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Modal styles */
  .ReactModal__Overlay {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    background-color: var(--overlay) !important;
    backdrop-filter: blur(2px);
    z-index: 80;
  }

  .ReactModal__Overlay--after-open{
      opacity: 1;
  }

  .ReactModal__Overlay--before-close{
      opacity: 0;
  }

  .ReactModal__Content--after-open {
    max-width: 90%;
    background-color: var(--surface) !important;
    border: 1px solid var(--border) !important;
    border-radius: var(--r-md) !important;
    box-shadow: var(--shadow-lg);
  }

  /* react-select segue os tokens para funcionar nos dois temas */
  .react-select__control {
    background-color: var(--surface) !important;
    border-color: var(--border-strong) !important;
    border-radius: var(--r-sm) !important;
    min-height: 4.4rem;
  }

  .react-select__control--is-focused {
    border-color: var(--accent) !important;
    box-shadow: 0 0 0 3px var(--accent-tint) !important;
  }

  .react-select__menu {
    background-color: var(--surface) !important;
    border: 1px solid var(--border) !important;
    box-shadow: var(--shadow-md) !important;
    z-index: 20;
  }

  .react-select__option--is-focused {
    background-color: var(--surface-2) !important;
  }

  .react-select__option--is-selected {
    background-color: var(--accent) !important;
    color: #fff !important;
  }

  .react-select__single-value,
  .react-select__input-container,
  .react-select__input {
    color: var(--ink) !important;
  }

  .react-select__multi-value {
    background-color: var(--accent-tint) !important;
    border-radius: var(--r-pill) !important;
  }

  .react-select__multi-value__label {
    color: var(--accent-deep) !important;
  }
`;
